/**
 * Teaming colors defined in src/assets/scss/teaming/_teaming-colors.scss
 * KEEP IN SYNC!
 * These are useful for Vuetify components (or other third party components)
 *   that expect colors to be passed via props. Otherwise, prefer using
 *   scss variables and custom classes over these computed properties.
 */
export default {
	computed: {
		white: () => "#ffffff",
		mono000: () => "#ffffff",
		black: () => "#000000",

		gray900: () => "#1a1f36",
		gray800: () => "#2a2f45",
		gray700: () => "#3c4257",
		gray600: () => "#4f566b",
		gray500: () => "#697386",
		gray400: () => "#8792a2",
		gray300: () => "#a3acb9",
		gray200: () => "#c1c9d2",
		gray100: () => "#e3e8ee",
		gray050: () => "#f7fafc",
		gray: () => "#8792a2", // gray400

		blue900: () => "#131f41",
		blue800: () => "#212d63",
		blue700: () => "#2f3d89",
		blue600: () => "#3d4eac",
		blue500: () => "#5469d4",
		blue400: () => "#6c8eef",
		blue300: () => "#7dabf8",
		blue200: () => "#a4cdfe",
		blue100: () => "#d6ecff",
		blue050: () => "#f5fbff",
		blue: () => "#6c8eef", // blue400

		cyan900: () => "#042235",
		cyan800: () => "#093353",
		cyan700: () => "#06457a",
		cyan600: () => "#075996",
		cyan500: () => "#067ab8",
		cyan400: () => "#3a97d4",
		cyan300: () => "#4db7e8",
		cyan200: () => "#7fd3ed",
		cyan100: () => "#c4f1f9",
		cyan050: () => "#edfdfd",
		cyan: () => "#3a97d4", // cyan400

		green900: () => "#082429",
		green800: () => "#0b3733",
		green700: () => "#0d4b3b",
		green600: () => "#0e6245",
		green500: () => "#09825d",
		green400: () => "#1ea672",
		green300: () => "#33c27f",
		green200: () => "#85d996",
		green100: () => "#cbf4c9",
		green050: () => "#efffed",
		green: () => "#1ea672", // green400

		yellow900: () => "#3a1607",
		yellow800: () => "#571f0d",
		yellow700: () => "#762b0b",
		yellow600: () => "#983705",
		yellow500: () => "#bb5504",
		yellow400: () => "#d97917",
		yellow300: () => "#e5993e",
		yellow200: () => "#efc078",
		yellow100: () => "#f8e5b9",
		yellow050: () => "#fcf9e9",
		yellow: () => "#d97917", // yellow400

		orange900: () => "#420e11",
		orange800: () => "#5d161b",
		orange700: () => "#7e1e23",
		orange600: () => "#9e2f28",
		orange500: () => "#c44c34",
		orange400: () => "#e56f4a",
		orange300: () => "#f5925e",
		orange200: () => "#f8b886",
		orange100: () => "#fee3c0",
		orange050: () => "#fffaee",
		orange: () => "#e56f4a", // orange400

		red900: () => "#420828",
		red800: () => "#5e1039",
		red700: () => "#80143f",
		red600: () => "#a41c4e",
		red500: () => "#cd3d64",
		red400: () => "#ed5f74",
		red300: () => "#fa8389",
		red200: () => "#fbb5b2",
		red100: () => "#fde2dd",
		red050: () => "#fff8f5",
		red: () => "#ed5f74", // red400

		purple900: () => "#2d0f55",
		purple800: () => "#401d6a",
		purple700: () => "#5b2b80",
		purple600: () => "#7b3997",
		purple500: () => "#a450b5",
		purple400: () => "#c96ed0",
		purple300: () => "#e28ddc",
		purple200: () => "#f0b4e4",
		purple100: () => "#fce0f6",
		purple050: () => "#fff8fe",
		purple: () => "#c96ed0", // purple400

		violet900: () => "#1f184e",
		violet800: () => "#352465",
		violet700: () => "#4b3480",
		violet600: () => "#61469b",
		violet500: () => "#8260c3",
		violet400: () => "#9c82db",
		violet300: () => "#b0a1e1",
		violet200: () => "#c7c2ea",
		violet100: () => "#e6e6fc",
		violet050: () => "#f8f9fe",
		violet: () => "#9c82db", // violet400

		//
		// DISC colors
		//
		discD: () => "#ed5f74",
		discDc: () => "#ed5f74",
		discDi: () => "#ed5f74",
		discDI: () => "#ed5f74",

		discId: () => "#d97917",
		discI: () => "#d97917",
		discIs: () => "#d97917",
		discIS: () => "#d97917",

		discSi: () => "#1ea672",
		discS: () => "#1ea672",
		discSc: () => "#1ea672",
		discSC: () => "#1ea672",

		discCs: () => "#3a97d4",
		discC: () => "#3a97d4",
		discCd: () => "#3a97d4",
		discCD: () => "#3a97d4",
	},
};



// WEBPACK FOOTER //
// ./src/components/ColorsMixin.js